import type { ReactNode } from "react";

export default function StudioPreviewCard(props: {
  title: string;
  eyebrow?: string;
  children: ReactNode;
}) {
  return (
    <section
      style={{
        borderRadius: 28,
        border: "1px solid rgba(54, 44, 35, 0.1)",
        background: "rgba(255, 252, 248, 0.96)",
        padding: "1.1rem",
        boxShadow: "0 22px 44px rgba(77, 61, 44, 0.08)",
      }}
    >
      {props.eyebrow ? (
        <div
          style={{
            fontSize: "0.72rem",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "#7b726a",
            fontWeight: 700,
            marginBottom: "0.45rem",
          }}
        >
          {props.eyebrow}
        </div>
      ) : null}
      <h2
        style={{
          margin: 0,
          fontSize: "1.05rem",
          color: "#2a2621",
          fontWeight: 700,
        }}
      >
        {props.title}
      </h2>
      <div style={{ marginTop: "0.85rem" }}>{props.children}</div>
    </section>
  );
}
